// About.jsx
import React from 'react';
import { useInView } from 'react-intersection-observer';
import './About.css';
import img from '../../../assets/About/img.png';
import { Link } from 'react-router-dom';

const About = () => {
  const { ref, inView } = useInView({
    triggerOnce: false,
    threshold: 0.3,
  });

  return (
    <div className="sobre-nosotros" ref={ref}>
      <div className={`imagen-container ${inView ? 'visible-left' : ''}`}>
        <img src={img} alt="Sobre nosotros" className="imagen-redonda" />
      </div>
      <div className={`contenido-container ${inView ? 'visible-right' : ''}`}>
        <h2>SOBRE NOSOTROS</h2>
        <p>
          Desarrollamos una amplia variedad de productos para satisfacer las necesidades de nuestros clientes,
          manteniendo altos estándares de calidad y excelencia. Nos comprometemos a ofrecer soluciones
          innovadoras que impulsen su éxito.
        </p>
        {/* <button className="boton">Conoce Más</button> */}
        <Link className='boton' to="/nosotros"> Conoce Más</Link>
      </div>
    </div>
  );
};

export default About;
